import { Box, Button, CardMedia, Dialog, Grid, IconButton, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { format, isValid } from 'date-fns';
import LoadingButton from '@mui/lab/LoadingButton';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import React, { useEffect, useRef, useState } from 'react';
import { MFSubmitButton, MFTextField } from '../../lib/formik';
import { useHistory } from 'react-router-dom';
import * as yup from 'yup';
import { Formik, setNestedObjectValues } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import {
  verifyPan,
  EnablePOA,
  IsApplicableForPOA,
  SendEmail,
  AcknowledgeAmlCheck,
  getApplicationToken,
  sendConsentEmail,
  getOCRDetails,
} from '../../redux-store/actions/onBoarding';
import { showError } from '../../redux-store/actions/auth';
import {
  AcknowledgeAmlCheckResponseBody,
  AmlSystemMatch,
  ApplicationProps,
  DistributorListType,
  EnablePOAResponseBody,
  IsApplicableForPOAResponseBody,
  OcrResponseBody,
  SendConsentEmailResponseBody,
  SendOtpResponseBody,
  VerifyOtpResponseBody,
  VerifyPanResponseBody,
} from '../../redux-store/types/api-types';
import CloseIcon from '@mui/icons-material/Close';
import { addJointHolder, createApplication } from '../../redux-store/actions/application';
import {
  emailRegex,
  individualPanRegex,
  nonIndividualPanRegex,
  phoneRegExp,
} from '../../utils/regex';
import { Location } from 'history';
import { Notes } from '../investors/components';
import { RequiredFieldsMessage } from '../RequiredFieldsMessage';
import MFCheckbox from '../../lib/formik/Checkbox';
import { DatePicker } from '../../lib/formik/DatePicker';
import {
  getCountryCodes,
  isMinor,
  maxAge,
  preventSpecialCharacters,
} from '../../utils/utilityFunctions';
import {
  AML_ALL_DISPLAY_MODE,
  APPLICATION_TYPE,
  ENABLE_Email_Consent,
  ENABLE_EMAIL_OTP,
  IS_DOB_APPLICABLE_FOR_AMC,
  ONBOARDING_OPTIONS,
  USER_ROLES,
} from '../../utils/constant';
import { CountryCode, isValidPhoneNumber } from 'libphonenumber-js';
import {
  AmlPopup,
  AmlPopupValues,
  ConfirmationDialog,
  CountryCodesDropDown,
} from '../commonComponents';
import { Link as RouterLink } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { RootStateType } from '../../redux-store/reducers';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import { getDirectApplicableFunds, getDist, getFundsList } from '../../redux-store/actions/funds';
import { distType, FundProps, GetFundsListResponseBody } from '../../redux-store/types/funds';
import { getDistributorById } from '../../redux-store/actions/userManagement';
interface Values {
  pan: string;
  dob: string;
  schemeId: string;
}

interface MValues {
  pan: string;
  mobile?: string;
  bypassOtp: boolean;
  skipOtpModal: boolean;
  emailId: string;
  hasPOA: boolean;
  dob: string;
  countryCode: string;
  countryNameAndCode: string;
  onboardingOtpEmailConsent?: string;
}
interface EValues {
  pan: string;
  emailId: string;
  dob: string;
}

export default function EnterPAN({
  location,
}: {
  location: Location<{
    firstHolderName: string;
    application: ApplicationProps;
    redirectTo: string;
    prefillPan?: string;
    prefillDob?: string;
    cmlId?: string;
    prefillMobile?: string;
    prefillEmail?: string;
  }>;
}): JSX.Element {
  const {
    redirectTo = '',
    firstHolderName = '',
    application,
    prefillPan = '',
    prefillDob = '',
    cmlId = '',
    prefillMobile = '',
    prefillEmail = '',
  } = location.state || {};
  const { id, applicants = [], hasPOA, schemeId = '' } = application || {};
  const isFromUploadFlow = Boolean(prefillPan);
  // Joint holder flow — redirectTo is set, disable Upload CML Copy and default to Manual Entry
  const isJointHolderFlow = Boolean(redirectTo);

  const [open, setOpen] = React.useState(false);
  const [onboardingMethod, setOnboardingMethod] = useState<'upload' | 'manual'>(
    isJointHolderFlow ? 'manual' : 'upload'
  );
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [uploadError, setUploadError] = useState<string>('');
  const [isDragging, setIsDragging] = useState(false);
  const [isVerifyingDoc, setIsVerifyingDoc] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const [amlPopup, setAmlPopup] = React.useState<{
    panVerificationToken: string;
    pan: string;
    dob: string;
    kraVerification: string;
  } | null>(null);
  const [amlFailedresponse, setAmlFailedresponse] = React.useState<AmlSystemMatch>();
  const [amlAcknowledgementLoading, setAmlAcknowledgementLoading] = React.useState(false);
  const [openDialog, setDialog] = useState<{ response: VerifyPanResponseBody } | null>(null);
  const [fundData, setFundData] = useState<FundProps[]>([]);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);

  const applicantPanNumbers = applicants.map((applicant) => applicant.panNo);
  const validationSchema1 = yup.object().shape({
    pan: yup
      .string()
      .uppercase()
      .length(10, 'PAN must be exactly 10 characters')
      .test('pan', (value, context) => {
        const fieldValue = value === undefined ? '' : value;
        const { path, createError } = context;
        if (!fieldValue) {
          return createError({
            message: 'PAN is required',
            path,
          });
        }
        if (fieldValue.split('')[3] === 'P' && !individualPanRegex.test(fieldValue)) {
          return createError({
            message: 'invalid PAN',
            path,
          });
        }
        if (!nonIndividualPanRegex.test(fieldValue)) {
          return createError({
            message: 'invalid PAN',
            path,
          });
        }
        if (
          !isFromUploadFlow &&
          fieldValue.split('')[3] === 'P' &&
          applicantPanNumbers.includes(fieldValue)
        ) {
          return createError({
            message: 'There is already same pan for an applicant associated with this application',
            path,
          });
        }
        return true;
      }),
    dob: yup.string().test('dob', (value, context) => {
      const fieldValue = value === undefined ? '' : value;
      const { path, createError, parent } = context;
      if (IS_DOB_APPLICABLE_FOR_AMC) {
        if (!fieldValue) {
          return createError({
            message: 'Date of birth is required',
            path,
          });
        }
        if (isMinor(fieldValue || '') && parent.pan?.split('')[3] === 'P') {
          return createError({
            message: 'Age should be greater than 18',
            path,
          });
        }
        if (maxAge(fieldValue || '') && parent.pan?.split('')[3] === 'P') {
          return createError({
            message: 'Age should be less than 125',
            path,
          });
        }
      }

      return true;
    }),
    schemeId: yup.string().nullable().required('Fund Scheme is required'),
  });
  const initialValues1: Values = {
    pan: prefillPan || '',
    dob: prefillDob || '',
    schemeId: schemeId ? schemeId : '',
  };
  const routingAfterPanVerification = async (
    response: VerifyPanResponseBody | AcknowledgeAmlCheckResponseBody,
    pan: string,
    dob: string
  ) => {
    if (hasPOA) {
      const { panVerificationToken } = response || {};
      const poaResponse = (await dispatch(
        EnablePOA({ panVerificationToken, powerOfAttorney: true })
      )) as unknown as EnablePOAResponseBody;
      const { applicantVerificationToken } = poaResponse;
      await dispatch(addJointHolder({ applicantVerificationToken }, id));
      history.push(redirectTo, { id });
      return;
    }
    if (response.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL) {
      return history.push('enter-email-id', {
        pan: pan.toUpperCase(),
        dob: dob,
        ...(response || {}),
      });
    }
    history.push('enter-mobile-number', {
      pan: pan.toUpperCase(),
      dob: dob,
      ...(response || {}),
      redirectTo,
      firstHolderName,
      application,
      ...(prefillMobile ? { prefillMobile } : {}),
      ...(prefillEmail ? { prefillEmail } : {}),
    });
  };
  const routingAfterKRAVerification = async (
    response: VerifyPanResponseBody,
    pan: string,
    dob: string
  ) => {
    if (!response.amlCheck) {
      const { system_match = [], referral_match = [] } = response.amlData || {};
      const matches = AML_ALL_DISPLAY_MODE
        ? [...system_match, ...referral_match]
        : [system_match[0] || referral_match[0]].filter(Boolean);
      setAmlFailedresponse(
        matches.length
          ? {
              ...matches[0],
              FURTHER_INFORMATION: matches
                .map((m) => m.FURTHER_INFORMATION)
                .filter(Boolean)
                .join('\n\n'),
              EXTERNAL_SOURCES: matches
                .map((m) => m.EXTERNAL_SOURCES)
                .filter(Boolean)
                .join('\n'),
            }
          : undefined
      );
      return setAmlPopup({
        panVerificationToken: response.panVerificationToken,
        pan: pan,
        dob: dob,
        kraVerification: response.kraVerification,
      });
    }
    routingAfterPanVerification(response, pan, dob);
  };
  const ALLOWED_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
  const MAX_FILE_SIZE_MB = 5;

  const validateFile = (file: File): string => {
    if (!ALLOWED_TYPES.includes(file.type)) {
      return 'Only JPG, JPEG, PNG or PDF files are allowed';
    }
    if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
      return `File size must not exceed ${MAX_FILE_SIZE_MB} MB`;
    }
    return '';
  };

  const handleFileSelect = (file: File) => {
    const error = validateFile(file);
    setUploadError(error);
    setUploadedFile(error ? null : file);
  };

  const handleFileDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files?.[0];
    if (file) handleFileSelect(file);
  };

  const handleFileInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) handleFileSelect(file);
  };

  const handleDocumentVerify = async () => {
    if (!uploadedFile) {
      setUploadError('Please upload a document to proceed');
      return;
    }
    try {
      setIsVerifyingDoc(true);
      const response = (await dispatch(getOCRDetails(uploadedFile))) as unknown as OcrResponseBody;

      history.push('review-fetched-details', response);
    } catch (e) {
      dispatch(showError((e as Error).message));
    } finally {
      setIsVerifyingDoc(false);
    }
  };

  const handleSubmit1 = async (values: Values) => {
    try {
      const { pan, dob, schemeId } = values;
      const response = (await dispatch(
        verifyPan({
          pan,
          dob,
          schemeId,
          ...(isFromUploadFlow && cmlId ? { cmlId } : {}),
        })
      )) as unknown as VerifyPanResponseBody;
      if (response.kraVerification === 'failure') {
        setDialog({ response });
        return;
      }
      routingAfterKRAVerification(response, pan, dob);
    } catch (e) {
      console.error((e as Error).message);
    }
  };
  const handleClose = () => {
    setAmlPopup(null);
  };

  useEffect(() => {
    let isComponentActive = true;
    (async function () {
      try {
        let user;
        if (!application?.distributor_id && ['distributor', 'subdistributor'].includes(role)) {
          user = (await dispatch(getDist())) as unknown as distType;
        }
        const res =
          application?.distributor_id || ['distributor', 'subdistributor'].includes(role) // Check if distributor or subdistributor is logged in or it is present in application
            ? ((
                (await dispatch(
                  getDistributorById(
                    application?.distributor_id
                      ? application?.distributor_id
                      : user?.distributorId || ''
                  )
                )) as unknown as DistributorListType
              ).planDetails.schemes as FundProps[])
            : ['rm'].includes(role) // Check if RM is logged in
            ? ((await dispatch(
                getDirectApplicableFunds({
                  ...(id ? { isActive: true } : { isActive: true, freezeStatus: false }),
                })
              )) as unknown as FundProps[])
            : (
                (await dispatch(
                  // For Amc Admin and others
                  getFundsList({
                    ...(id ? { isActive: true } : { isActive: true, freezeStatus: false }),
                  }) //id present means existing application and for existing application we need not send freezeStatus.
                )) as unknown as GetFundsListResponseBody
              ).funds;
        if (!isComponentActive) return;
        setFundData(res?.filter((fund) => fund.isActive && (!!id || fund.freezeStatus === false)));
      } catch (e) {
        console.log((e as Error).message);
      }
    })();
    return () => {
      isComponentActive = false;
    };
  }, []);

  const onSubmit = async (values: AmlPopupValues) => {
    try {
      setAmlAcknowledgementLoading(true);
      const { amlComments, amlAcknowledgement } = values;
      const {
        panVerificationToken = '',
        pan = '',
        dob = '',
        kraVerification = '',
      } = amlPopup || {};
      setAmlPopup(null);
      const response = (await dispatch(
        AcknowledgeAmlCheck({ panVerificationToken, amlComments, amlAcknowledgement })
      )) as unknown as AcknowledgeAmlCheckResponseBody;
      routingAfterPanVerification({ ...response, kraVerification: kraVerification }, pan, dob);
    } catch (e) {
      console.error((e as Error).message);
    }
  };
  // ── Shared form fields ── extracted so both panels reuse the same JSX ──

  const renderFormFields = ({
    resetForm,
    setValues,
    values,
    panDisabled = false,
    dobDisabled = false,
  }: {
    resetForm: () => void;
    setValues: (v: Values) => void;
    values: Values;
    panDisabled?: boolean;
    dobDisabled?: boolean;
  }) => (
    <>
      <Grid container>
        <Grid item xs={12}>
          <RequiredFieldsMessage />
        </Grid>
      </Grid>
      <MFTextField
        label="PAN *"
        name="pan"
        placeholder="Enter PAN"
        required
        autoComplete="off"
        inputProps={{ style: { textTransform: 'uppercase' } }}
        disabled={panDisabled}
      />
      {IS_DOB_APPLICABLE_FOR_AMC && (
        <DatePicker
          label={'Date of Birth/Incorporation'}
          inputLabelStyles={{
            transform: 'unset',
            fontSize: 14,
            fontWeight: 500,
            color: 'rgba(0,0,0,0.7)',
          }}
          placeholder={'DD/MM/YYYY'}
          name="dob"
          required
          disabled={dobDisabled}
        />
      )}
      <SearchableSelect
        name="schemeId"
        label="Fund (Scheme) *"
        items={(fundData as FundProps[])
          ?.sort((rm1, rm2) =>
            (rm1['schemeName'] || '').toString().localeCompare((rm2['schemeName'] || '').toString())
          )
          .map((item) => ({
            key: item.schemeName,
            value: item.id,
          }))}
        searchFieldPlaceholder={'Search Fund'}
        disabled={Boolean(schemeId)}
      />
      <MFSubmitButton label="Verify PAN" loadingEnable={amlAcknowledgementLoading} />
      <Notes
        displayContent={
          'Add the applicant(s) PAN and if the PAN is KRA verified, the contact details will be populated automatically. Pan will be checked against World-Check database for AML compliance.'
        }
      />
      {/* Dialogs shared across both usages */}
      <Dialog open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            p: { xs: 2, sm: 8 },
            borderRadius: '10px',
            maxWidth: 800,
            height: { xs: '90%', md: 'unset' },
            overflowY: 'auto',
          }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              '& .MuiButton-root': { minWidth: 200, fontSize: 16 },
            }}>
            <Box sx={{ mb: 8 }}>
              <CardMedia
                component="img"
                src="/images/warning-icon-red.svg"
                sx={{ width: 'unset' }}
              />
            </Box>
            <Typography
              sx={{
                fontSize: 20,
                fontWeight: 500,
                color: '#337FC9',
                textAlign: 'center',
                width: '70%',
                mb: 5,
              }}>
              Unable to verify the details please contact admin
            </Typography>
            <Button
              variant="contained"
              onClick={() => {
                resetForm();
                setOpen(false);
              }}
              sx={{ color: 'common.white' }}>
              Enter another PAN
            </Button>
          </Box>
        </Box>
      </Dialog>
      <AmlPopup
        handleClose={handleClose}
        amlPopupOpen={amlPopup !== null}
        onSubmit={onSubmit}
        FURTHER_INFORMATION={amlFailedresponse?.FURTHER_INFORMATION}
        EXTERNAL_SOURCES={amlFailedresponse?.EXTERNAL_SOURCES}
        displayDocInfo={true}
      />
      <ConfirmationDialog
        message={`KRA verification failed, Are you sure you want to proceed with this PAN ?`}
        open={openDialog != null}
        setOpen={() => setDialog(null)}
        onSave={async () => {
          if (openDialog) {
            setDialog(null);
            routingAfterKRAVerification(openDialog.response, values.pan, values.dob);
          }
        }}
        onCancel={() => {
          setDialog(null);
          setValues({ ...values, pan: '', dob: '' });
        }}
      />
    </>
  );

  return (
    <>
      {/* ── Onboarding Method Toggle ───────────────────────────────────── */}
      <Box sx={{ mb: 3 }}>
        <Typography sx={{ fontSize: 13, color: 'text.secondary', mb: 1, fontWeight: 400 }}>
          Onboarding Method
        </Typography>
        <Box sx={{ display: 'flex', gap: 1.5 }}>
          {(['upload', 'manual'] as const).map((method) => {
            // Disable Manual Entry if user came from Upload CML Copy flow
            // Disable Upload CML Copy if this is a joint holder flow (manual only)
            const isDisabled =
              (method === 'manual' && isFromUploadFlow) ||
              (method === 'upload' && isJointHolderFlow);
            return (
              <Button
                key={method}
                variant="outlined"
                disabled={isDisabled}
                onClick={() => {
                  setOnboardingMethod(method);
                  setUploadedFile(null);
                  setUploadError('');
                }}
                sx={{
                  borderRadius: '8px',
                  textTransform: 'none',
                  fontWeight: method === onboardingMethod ? 700 : 400,
                  fontSize: 14,
                  px: 3,
                  py: 1.2,
                  borderColor: method === onboardingMethod ? 'primary.main' : 'grey.300',
                  color: method === onboardingMethod ? 'primary.main' : 'text.secondary',
                  backgroundColor: 'common.white',
                  '&:hover': {
                    borderColor: isDisabled ? 'grey.300' : 'primary.main',
                    backgroundColor: 'common.white',
                  },
                }}>
                {method === 'upload' ? 'Upload CML Copy' : 'Manual Entry'}
              </Button>
            );
          })}
        </Box>
      </Box>

      {/* ── Upload CML Copy Panel ──────────────────────────────────────── */}
      {onboardingMethod === 'upload' && (
        <Box>
          {isFromUploadFlow ? (
            <Formik
              initialValues={initialValues1}
              validationSchema={validationSchema1}
              onSubmit={handleSubmit1}>
              {({ handleSubmit, resetForm, setValues, values }) => (
                <Box component="form" noValidate onSubmit={handleSubmit}>
                  {renderFormFields({
                    resetForm,
                    setValues,
                    values,
                    panDisabled: true,
                    dobDisabled: true,
                  })}
                </Box>
              )}
            </Formik>
          ) : (
            <>
              <Typography sx={{ fontSize: 13, color: 'text.secondary', mb: 1, fontWeight: 400 }}>
                Upload CML Copy
              </Typography>
              <Box
                onDragOver={(e) => {
                  e.preventDefault();
                  setIsDragging(true);
                }}
                onDragLeave={() => setIsDragging(false)}
                onDrop={handleFileDrop}
                onClick={() => fileInputRef.current?.click()}
                sx={{
                  border: '1.5px dashed',
                  borderColor: isDragging ? 'primary.main' : 'grey.300',
                  borderRadius: '12px',
                  backgroundColor: isDragging ? '#e8eef8' : 'grey.50',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  py: 4,
                  px: 2,
                  cursor: 'pointer',
                  transition: 'border-color 0.2s, background-color 0.2s',
                  '&:hover': { borderColor: 'primary.main' },
                }}>
                <input
                  ref={fileInputRef}
                  type="file"
                  accept=".jpg,.jpeg,.png,.pdf"
                  hidden
                  onChange={handleFileInputChange}
                />
                <Box
                  sx={{
                    width: 56,
                    height: 56,
                    borderRadius: '50%',
                    backgroundColor: '#e8eef8',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mb: 1.5,
                  }}>
                  <CloudUploadIcon sx={{ fontSize: 28, color: 'primary.main' }} />
                </Box>
                {uploadedFile ? (
                  <Typography sx={{ fontSize: 14, color: 'success.main', fontWeight: 500 }}>
                    {uploadedFile.name}
                  </Typography>
                ) : (
                  <>
                    <Typography sx={{ fontSize: 14, color: 'text.primary' }}>
                      <Typography
                        component="span"
                        sx={{
                          fontWeight: 700,
                          color: 'primary.main',
                          textDecoration: 'underline',
                          cursor: 'pointer',
                        }}>
                        Browser File
                      </Typography>{' '}
                      JPG, JPEG, PNG OR PDF
                    </Typography>
                    <Typography sx={{ fontSize: 13, color: 'text.secondary', mt: 0.5 }}>
                      (Max. File size: {MAX_FILE_SIZE_MB} MB)
                    </Typography>
                  </>
                )}
              </Box>

              {uploadError && (
                <Typography sx={{ fontSize: 12, color: 'error.main', mt: 0.75, ml: 0.5 }}>
                  {uploadError}
                </Typography>
              )}

              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: 1,
                  backgroundColor: '#f0f4fb',
                  borderRadius: '8px',
                  p: 1.5,
                  mt: 2,
                }}>
                <InfoOutlinedIcon
                  sx={{ fontSize: 18, color: 'primary.main', mt: '1px', flexShrink: 0 }}
                />
                <Typography sx={{ fontSize: 13, color: 'text.secondary', lineHeight: 1.5 }}>
                  Data will be extracted from document, KRA and gets pre-populated
                </Typography>
              </Box>
              <LoadingButton
                fullWidth
                variant="contained"
                loading={isVerifyingDoc}
                loadingPosition="start"
                onClick={handleDocumentVerify}
                sx={{
                  mt: 3,
                  mb: 2,
                  color: 'common.white',
                  lineHeight: 1.5,
                  fontSize: 14,
                }}>
                Verify
              </LoadingButton>
            </>
          )}
        </Box>
      )}

      {/* ── Manual Entry Panel ─────────────────────────────────────────── */}
      {onboardingMethod === 'manual' && (
        <Formik
          initialValues={initialValues1}
          validationSchema={validationSchema1}
          onSubmit={handleSubmit1}>
          {({ handleSubmit, resetForm, setValues, values }) => (
            <Box component="form" noValidate onSubmit={handleSubmit}>
              {renderFormFields({ resetForm, setValues, values })}
            </Box>
          )}
        </Formik>
      )}
    </>
  );
}
export function EnterMobile({
  location,
}: {
  location: Location<{
    redirectTo: string;
    panVerificationToken: string;
    pan: string;
    firstHolderName: string;
    application: ApplicationProps;
    dob: string;
    kraVerification: string;
    amlCheck?: boolean;
    prefillMobile?: string;
    prefillEmail?: string;
  }>;
}): JSX.Element {
  const {
    redirectTo = '',
    panVerificationToken,
    pan,
    firstHolderName = '',
    application,
    dob,
    kraVerification = '',
    amlCheck = false,
    prefillMobile = '',
    prefillEmail = '',
  } = location.state || {};
  const { id, applicants = [] } = application || {};
  const dispatch = useDispatch();
  const history = useHistory();
  const [disablePOA, setDisablePOA] = useState(false);
  const applicantMobileNumbers = applicants.map((applicant) => applicant.mobile);
  const { enqueueSnackbar } = useSnackbar();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);

  const validationSchema1 = yup.object().shape({
    pan: yup
      .string()
      .uppercase()
      .length(10, 'PAN must be exactly 10 characters')
      .test('pan', (value, context) => {
        const fieldValue = value === undefined ? '' : value;
        const { path, createError } = context;
        if (!fieldValue) {
          return createError({
            message: 'PAN is required',
            path,
          });
        }
        if (fieldValue.split('')[3] === 'P' && !individualPanRegex.test(fieldValue)) {
          return createError({
            message: 'invalid PAN',
            path,
          });
        }
        if (!nonIndividualPanRegex.test(fieldValue)) {
          return createError({
            message: 'invalid PAN',
            path,
          });
        }
        return true;
      }),
    emailId: yup.string().when('hasPOA', {
      is: (value: boolean) => (disablePOA ? true : !value) && ENABLE_EMAIL_OTP,
      then: yup.string().test('emailId', (value, context) => {
        const { createError, path, parent } = context;
        if (!value) {
          return createError({
            message: 'Email Id is required',
            path,
          });
        }
        if (!emailRegex.test(value)) {
          return createError({
            message: 'Invalid Email Id',
            path,
          });
        }
        return true;
      }),
    }),

    mobile: yup.string().when('hasPOA', {
      is: (value: boolean) => (disablePOA ? true : !value),
      then: yup.string().test('mobile', (value, context) => {
        const { createError, path, parent } = context;
        const codesList = getCountryCodes()
          .map((codes) => {
            if (codes.label === parent.countryNameAndCode) {
              return codes.countryCode;
            }
          })
          .filter((ele) => ele)
          .toString();
        if (!value) {
          return createError({
            message: 'Mobile number is required',
            path,
          });
        }
        if (parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
          return createError({
            message: 'Invalid Mobile number',
            path,
          });
        }
        if (!isValidPhoneNumber(value, codesList as CountryCode)) {
          return createError({
            message: 'Invalid Mobile number',
            path,
          });
        }
        // Skip duplicate check if this mobile was pre-filled from CML (it belongs to this applicant)
        if (!prefillMobile && applicantMobileNumbers.includes(value)) {
          return createError({
            message:
              'There is already same mobile number for an applicant associated with this application',
            path,
          });
        }
        return true;
      }),
    }),
    countryNameAndCode: yup
      .string()
      .nullable()
      .when('hasPOA', {
        is: (value: boolean) => (disablePOA ? true : !value),
        then: yup.string().test('countryNameAndCode', (value, context) => {
          const { createError, path, parent } = context;
          const codesList = getCountryCodes()
            .map((codes) => {
              if (codes.label === value) {
                return codes.countryCode;
              }
            })
            .filter((ele) => ele)
            .toString();
          if (!value) {
            return createError({
              message: 'Country Code is required',
              path,
            });
          }
          if (parent.mobile && !isValidPhoneNumber(parent.mobile, codesList as CountryCode)) {
            return createError({
              message: 'Invalid Mobile number',
              path,
            });
          }

          return true;
        }),
      }),
  });
  const initialValues1: MValues = {
    pan: pan,
    mobile: prefillMobile || '',
    emailId: prefillEmail || '',
    bypassOtp: false,
    skipOtpModal: false,
    hasPOA: false,
    dob: dob,
    countryCode: '+91',
    countryNameAndCode: 'India: +91',
    onboardingOtpEmailConsent: 'otp',
  };

  const handleCreateApplication = async (applicantVerificationToken: string) => {
    const res = (await dispatch(
      createApplication({ applicantVerificationToken })
    )) as unknown as ApplicationProps;
    history.push('/application/distributor-details', { ...(res || {}) });
  };

  const handleSubmit1 = async (values: MValues) => {
    const {
      pan,
      mobile = '',
      bypassOtp = false,
      hasPOA,
      emailId,
      countryCode = '+91',
      countryNameAndCode = 'India: +91',
      onboardingOtpEmailConsent = 'otp',
    } = values;
    if (hasPOA) {
      const poaResponse = (await dispatch(
        EnablePOA({ panVerificationToken, powerOfAttorney: true })
      )) as unknown as EnablePOAResponseBody;
      const { applicantVerificationToken } = poaResponse;
      await handleCreateApplication(applicantVerificationToken);
      return;
    }
    if (ONBOARDING_OPTIONS[onboardingOtpEmailConsent] === ONBOARDING_OPTIONS.email_consent) {
      (await dispatch(
        sendConsentEmail({
          phoneNumber: mobile.trim(),
          emailId,
          panVerificationToken,
          countryCode: countryNameAndCode?.split(':')[1].trim(),
          countryNameAndCode,
          applicationId: id || '',
        })
      )) as unknown as SendConsentEmailResponseBody;
      enqueueSnackbar('Email sent successfully', {
        variant: 'success',
        autoHideDuration: 3000,
      });
      return history.push(
        [USER_ROLES.AMCAPPROVER, USER_ROLES.POAAPPROVER].includes(role)
          ? `/applications-list`
          : '/applications'
      );
    }

    const response = (await dispatch(
      getApplicationToken({
        phoneNumber: mobile.trim(),
        emailId,
        panVerificationToken,
        countryCode: countryNameAndCode?.split(':')[1].trim(),
        countryNameAndCode,
      })
    )) as unknown as VerifyOtpResponseBody;

    const { applicantVerificationToken } = response || {};
    // if (bypassOtp) {
    if (id && redirectTo) {
      (await dispatch(
        addJointHolder({ applicantVerificationToken }, id)
      )) as unknown as ApplicationProps;
      history.push(redirectTo, { id });
      return;
    }
    //   handleCreateApplication(applicantVerificationToken);
    //   return;
    // }
    handleCreateApplication(applicantVerificationToken);
    // history.push('enter-otp', {
    //   pan,
    //   unmaskedphone: mobile.trim(),
    //   umaskedemailId: emailId,
    //   mobile: phoneNumber,
    //   panVerificationToken,
    //   redirectTo,
    //   application,
    //   email: (response || {}).emailId,
    //   firstHolderName,
    //   countryCode: countryNameAndCode?.split(':')[1].trim(),
    //   countryNameAndCode,
    //   ...(response || {}),
    // });
  };

  useEffect(() => {
    (async function () {
      const res = (await dispatch(
        IsApplicableForPOA()
      )) as unknown as IsApplicableForPOAResponseBody;
      const { powerOfAttorney } = res;
      setDisablePOA(
        application
          ? application.hasPOA
            ? application.hasPOA
            : !application.hasPOA
          : !powerOfAttorney
      );
    })();
  }, []);

  return (
    <>
      <Formik
        initialValues={initialValues1}
        validationSchema={validationSchema1}
        onSubmit={handleSubmit1}>
        {({
          handleSubmit,
          values,
          validateForm,
          isSubmitting,
          setTouched,
          setErrors,
          setFieldValue,
        }) => (
          <Box component="form" noValidate onSubmit={handleSubmit}>
            <Typography
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontSize: { xs: 22, sm: 24 },
                fontWeight: 700,
                color: '#1C2D47',
                mb: 0.5,
              }}>
              Contact Details
            </Typography>
            <Typography
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontSize: 14,
                fontWeight: 400,
                color: '#6B7280',
                mb: 2.5,
              }}>
              Confirm contact information for OTP verification.
            </Typography>

            <Box
              sx={{
                border: '1px solid #E5E7EB',
                borderRadius: '12px',
                width: { xs: '100%', sm: '540px' },
                maxWidth: '390px',
                minHeight: '171px',
                height: 'auto',
                p: 2,
                mb: 3,
                bgcolor: '#FAFBFC',
              }}>
              <Typography
                sx={{
                  fontFamily: 'Inter, sans-serif',
                  fontSize: 14,
                  fontWeight: 600,
                  letterSpacing: '0.08em',
                  color: '#6B7280',
                  mb: 1.5,
                }}>
                PAN DETAILS
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'Inter, sans-serif',
                  fontSize: 13,
                  fontWeight: 500,
                  color: '#6B7280',
                  mb: 0.25,
                }}>
                PAN
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  flexWrap: 'wrap',
                  gap: 1,
                  mb: 1.5,
                }}>
                <Typography
                  sx={{
                    fontFamily: 'Inter, sans-serif',
                    fontSize: 14,
                    fontWeight: 600,
                    color: '#111827',
                    textTransform: 'uppercase',
                    mr: 0.5,
                  }}>
                  {pan || '—'}
                </Typography>
                {(kraVerification === 'success' || amlCheck) && (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, minWidth: 0 }}>
                    <CheckCircleIcon sx={{ fontSize: 16, color: '#16A34A', flexShrink: 0 }} />
                    <Typography
                      sx={{
                        fontFamily: 'Inter, sans-serif',
                        fontSize: 12,
                        fontWeight: 500,
                        color: '#16A34A',
                        lineHeight: 1.4,
                      }}>
                      {[
                        kraVerification === 'success' ? 'KYC Verified' : null,
                        amlCheck ? 'AML Check Passed' : null,
                        kraVerification === 'success' ? 'PAN Aadhar Linked' : null,
                      ]
                        .filter(Boolean)
                        .join(', ')}
                    </Typography>
                  </Box>
                )}
              </Box>
              {IS_DOB_APPLICABLE_FOR_AMC && (
                <>
                  <Typography
                    sx={{
                      fontFamily: 'Inter, sans-serif',
                      fontSize: 13,
                      fontWeight: 500,
                      color: '#6B7280',
                      mb: 0.25,
                    }}>
                    Date of Birth
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: 'Inter, sans-serif',
                      fontSize: 14,
                      fontWeight: 600,
                      color: '#111827',
                    }}>
                    {dob && isValid(new Date(dob))
                      ? format(new Date(dob), 'dd/MM/yyyy')
                      : dob || '—'}
                  </Typography>
                </>
              )}
            </Box>

            <MFCheckbox
              name="hasPOA"
              label="Power of Attorney"
              color="primary"
              sx={{
                '.MuiTypography-root': {
                  color: 'primary.main',
                  fontWeight: 500,
                  fontSize: 14,
                  letterSpacing: '0.9625px',
                },
              }}
              disabled={disablePOA}
            />
            {!values.hasPOA && (
              <>
                <MFTextField
                  label="Enter Mobile"
                  name="mobile"
                  placeholder="Enter Mobile"
                  required
                  disabled={Boolean(prefillMobile)}
                  onKeyDown={(e) => {
                    preventSpecialCharacters(e);
                  }}
                  startAdornment={
                    <CountryCodesDropDown
                      name={'countryNameAndCode'}
                      value={values.countryNameAndCode}
                    />
                  }
                />
                {ENABLE_EMAIL_OTP && (
                  <MFTextField
                    autoComplete="off"
                    label="Enter E-mail"
                    name="emailId"
                    placeholder="Enter E-mail"
                    required
                    disabled={Boolean(prefillEmail)}
                  />
                )}
                {ENABLE_Email_Consent && (
                  <Box sx={{ mt: 2, mb: 1 }}>
                    <Typography
                      sx={{
                        fontFamily: 'Inter, sans-serif',
                        fontSize: 14,
                        fontWeight: 500,
                        color: 'rgba(0,0,0,0.7)',
                        mb: 1,
                      }}>
                      Authentication Type{' '}
                      <Box component="span" sx={{ color: '#d32f2f' }}>
                        *
                      </Box>
                    </Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5 }}>
                      {Object.keys(ONBOARDING_OPTIONS).map((option) => {
                        const isSelected = values.onboardingOtpEmailConsent === option;
                        return (
                          <Button
                            key={option}
                            type="button"
                            variant="outlined"
                            onClick={() => setFieldValue('onboardingOtpEmailConsent', option)}
                            sx={{
                              textTransform: 'none',
                              borderRadius: '20px',
                              px: 2.5,
                              py: 0.75,
                              minWidth: 'unset',
                              fontFamily: 'Inter, sans-serif',
                              fontSize: 14,
                              fontWeight: 500,
                              borderColor: isSelected ? '#2057A6' : '#D1D5DB',
                              color: isSelected ? '#2057A6' : '#6B7280',
                              bgcolor: '#FFFFFF',
                              '&:hover': {
                                borderColor: isSelected ? '#2057A6' : '#9CA3AF',
                                bgcolor: '#FFFFFF',
                              },
                            }}>
                            {ONBOARDING_OPTIONS[option]}
                          </Button>
                        );
                      })}
                    </Box>
                  </Box>
                )}
                <Notes
                  displayContent={
                    'This mobile number and email id will be used for all future communication related to this investment.'
                  }
                />
              </>
            )}
            <MFSubmitButton
              label={
                ONBOARDING_OPTIONS[values.onboardingOtpEmailConsent || ''] ===
                ONBOARDING_OPTIONS.email_consent
                  ? 'Send Email'
                  : 'Proceed'
              }
            />
            {/* <MFSubmitButton label={values.hasPOA ? 'Continue' : 'Get OTP'} />
            {!values.hasPOA && (
              <Button
                variant="outlined"
                fullWidth
                sx={{
                  color: 'primary.main',
                  fontWeight: 500,
                  fontSize: 14,
                  mt: 0.5,
                  lineHeight: 1.5,
                }}
                onClick={async () => {
                  const error = await validateForm();
                  if (Object.keys(error).length) {
                    setTouched(setNestedObjectValues(error, true));
                    setErrors(error);
                    return;
                  }
                  setFieldValue('skipOtpModal', true);
                }}>
                Skip OTP Verification
              </Button>
            )} */}
            <Dialog open={values.skipOtpModal} onClose={() => setFieldValue('skipOtpModal', false)}>
              <Box
                sx={{
                  borderRadius: '10px',
                  // width: { xs: '70%', sm: '70%' },
                  maxWidth: 800,
                  height: { xs: '90%', md: 'unset' },
                  overflowY: 'auto',
                }}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    p: 3,
                    '& .MuiButton-root': {
                      minWidth: 200,
                      fontSize: 16,
                    },
                  }}>
                  <IconButton
                    onClick={() => setFieldValue('skipOtpModal', false)}
                    sx={{ alignSelf: 'flex-end' }}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                  {/* <Box sx={{ mb: 4 }}>
                    <CardMedia
                      component="img"
                      src="/images/warning-icon-red.svg"
                      sx={{ width: 'unset' }}
                    />
                  </Box> */}
                  <Typography
                    sx={{
                      fontSize: 20,
                      fontWeight: 500,
                      color: '#337FC9',
                      textAlign: 'center',
                      mb: 5,
                      width: '90%',
                    }}>
                    Are you sure you want to Skip OTP Verification?
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      justifyContent: 'space-around',
                      width: '100%',
                    }}>
                    <Button
                      variant="outlined"
                      disabled={isSubmitting}
                      onClick={() => setFieldValue('skipOtpModal', false)}
                      sx={{ color: 'primary.main', mb: 2 }}>
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      sx={{ mb: 2 }}
                      onClick={() => {
                        setFieldValue('bypassOtp', true);
                        handleSubmit();
                      }}>
                      Continue
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Dialog>
          </Box>
        )}
      </Formik>
    </>
  );
}

export function EnterEmailId({
  location,
}: {
  location: Location<{
    panVerificationToken: string;
    pan: string;
    dob: string;
  }>;
}): JSX.Element {
  const { panVerificationToken, pan, dob } = location.state || {};
  const dispatch = useDispatch();
  const history = useHistory();
  const validationSchema1 = yup.object().shape({
    pan: yup
      .string()
      .uppercase()
      .length(10, 'PAN must be exactly 10 characters')
      .test('pan', (value, context) => {
        const fieldValue = value === undefined ? '' : value;
        const { path, createError } = context;
        if (!fieldValue) {
          return createError({
            message: 'PAN is required',
            path,
          });
        }
        if (fieldValue.split('')[3] === 'P' && !individualPanRegex.test(fieldValue)) {
          return createError({
            message: 'invalid PAN',
            path,
          });
        }
        if (!nonIndividualPanRegex.test(fieldValue)) {
          return createError({
            message: 'invalid PAN',
            path,
          });
        }
        return true;
      }),
    emailId: yup
      .string()
      .nullable()
      .matches(emailRegex, 'invalid Email ID')
      .required('Email is required'),
  });
  const initialValues1: EValues = {
    pan: pan,
    emailId: '',
    dob: dob,
  };

  const handleSubmit1 = async (values: EValues) => {
    const { emailId } = values;
    const response = (await dispatch(
      SendEmail({ panVerificationToken, emailId })
    )) as unknown as VerifyOtpResponseBody;
    const { applicantVerificationToken } = response || {};
    const res = (await dispatch(
      createApplication({ applicantVerificationToken })
    )) as unknown as ApplicationProps;
    history.push('/non-individual-application', { ...(res || {}) });
    // history.push('verify-documents', {
    //   applicantVerificationToken,
    // });
  };

  return (
    <>
      <Formik
        initialValues={initialValues1}
        validationSchema={validationSchema1}
        onSubmit={handleSubmit1}>
        {({ handleSubmit }) => (
          <Box component="form" noValidate onSubmit={handleSubmit}>
            <Box sx={{ position: 'relative' }}>
              <Box sx={{ position: 'absolute', right: 0, top: 15 }}>
                <CardMedia
                  component="img"
                  src="/images/tick.svg"
                  sx={{ width: '18px', float: 'right' }}
                />
              </Box>
              <MFTextField
                label="PAN"
                name="pan"
                placeholder="Enter PAN"
                required
                inputProps={{ style: { textTransform: 'uppercase' } }}
                disabled={true}
              />
              {IS_DOB_APPLICABLE_FOR_AMC && (
                <DatePicker
                  label={'Date of Birth/Incorporation'}
                  inputLabelStyles={{
                    transform: 'unset',
                    fontSize: 14,
                    fontWeight: 500,
                    color: 'rgba(0,0,0,0.7)',
                  }}
                  placeholder={'Enter Date of birth'}
                  name="dob"
                  disabled={true}
                />
              )}
            </Box>
            <MFTextField
              autoComplete="off"
              autoFocus
              label="Email ID"
              name="emailId"
              placeholder="Enter Email ID"
              required
            />

            <Notes
              displayContent={
                'This mobile number and email id will be used for all future communication related to this investment.'
              }
            />
            <MFSubmitButton label={'Proceed'} />
          </Box>
        )}
      </Formik>
    </>
  );
}
